import { render, staticRenderFns } from "./pointContent.vue?vue&type=template&id=3ba02f98&scoped=true"
import script from "./pointContent.vue?vue&type=script&lang=ts"
export * from "./pointContent.vue?vue&type=script&lang=ts"
import style0 from "./pointContent.vue?vue&type=style&index=0&id=3ba02f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba02f98",
  null
  
)

export default component.exports